var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3671 2.19596C14.7816 1.61077 13.9876 1.28204 13.1597 1.28204C12.3318 1.28204 11.5378 1.61077 10.9522 2.19596L10.2581 2.89007L10.2477 2.87964L9.01937 4.10794L9.02864 4.11953L2.21504 10.9331C1.61778 11.5307 1.28225 12.3409 1.28223 13.1858V15.413C1.28223 15.6435 1.37379 15.8645 1.53677 16.0275C1.69976 16.1905 1.92081 16.282 2.15131 16.282H4.37848C5.2235 16.2817 6.03378 15.9458 6.63114 15.3481L15.3683 6.61206C15.9535 6.02646 16.2822 5.23247 16.2822 4.40459C16.2822 3.57672 15.9535 2.78272 15.3683 2.19712L15.3671 2.19596ZM10.2581 5.34783L3.4445 12.1614C3.31001 12.296 3.20333 12.4557 3.13056 12.6314C3.05779 12.8072 3.02035 12.9956 3.02039 13.1858V14.5439H4.37848C4.76203 14.5439 5.13168 14.3909 5.40167 14.1198L12.2153 7.30617L10.2581 5.34783ZM13.4447 6.0767L14.1388 5.3826C14.2725 5.25516 14.3792 5.1023 14.4529 4.93299C14.5266 4.76368 14.5656 4.58135 14.5678 4.39672C14.5699 4.2121 14.5351 4.02891 14.4655 3.85792C14.3958 3.68694 14.2926 3.53162 14.162 3.4011C14.0314 3.27058 13.876 3.16749 13.705 3.09791C13.534 3.02832 13.3508 2.99364 13.1661 2.99591C12.9815 2.99818 12.7992 3.03734 12.6299 3.11111C12.4607 3.18487 12.3079 3.29174 12.1805 3.42543L11.4876 4.11953L13.4447 6.0767Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8a7213a3ab14254481264fc9e7c8df9a.svg";
export { ForwardRef as ReactComponent };